<template>
  <div>
    <video
      ref="videoPlayer"
      :src="url"
      width="100%"
      height="auto"
      controls
      controlsList="nodownload"
      disablePictureInPicture
      id="video-player"
      type="mp4"
    ></video>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    url: String,
  },
};
</script>